<template>
  <div :class="`preview-${activeMode}`">
    <Banner type="secondary">
      <h1>Looks Good</h1>
      <h2>And works flawlessly</h2>
    </Banner>

    <div class="site-setup-preview">
      <div class="preview-controls desktop-only">
        <button
          v-for="(mode, index) in previewModes"
          :key="`mode-${index}`"
          @click="changeMode(mode)"
          class="preview-size"
          :class="{'is-active': modeActive(mode)}"
        >
          <Sprite :name="mode" />
        </button>
      </div>

      <SitePreviewer class="desktop-only setup-previewer" :key="_uid" :iframeSrc="iframeSrc" />
      <p class="mobile-only centered">Your screen is a bit small to show you a preview, but you can still proceed by tapping <strong>Finish Setup</strong> below.</p>

      <router-link class="btn final-step is-primary" :to="{
        name: 'onboarding-video',
        params: {
          companyId: this.companyId,
          siteId: this.siteId
        }
      }">
        Finish Setup
      </router-link>
    </div>
  </div>
</template>

<script>
import SitePreviewer from '@/components/SitePreviewer'
import Banner from '@/components/Banner'

import Sprite from '@/components/Sprite'

import {readCompanySiteData} from '@/lib/sites'

export default {
  name: 'sitePreview',

  data() {
    return {
      site: {},
      activeMode: 'desktop',
      previewModes: ['mobile', 'tablet', 'desktop']
    }
  },

  props: {
    companyId: String,
    siteId: String
  },

  components: {
    SitePreviewer,
    Banner,
    Sprite
  },

  computed: {
    iframeSrc() {
      return `https://${this.site.domain}`
    },

    modeActive() {
      return (mode) => {
        return mode === this.activeMode
      }
    }
  },

  methods: {
    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    },

    changeMode(mode) {
      this.activeMode = mode
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.site-setup-preview
  padding: $gap-medium

  .preview-controls
    text-align: center
    margin-bottom: $gap-medium

  .final-step
    animation: pulse 1s infinite ease-in-out
    position: fixed
    bottom: $gap-small
    margin-right: $gap-small
    right: 0

  .sprite
    width: 20px
    height: 20px
    fill: rgba(0, 0, 0, 0.5)

  .preview-size
    transition: all .5s ease-in-out
    opacity: 0.5

    &.is-active
      transform: scale(1.25)
      opacity: 1

  .setup-previewer
    transform: scale(0.75) translate(0, -130px)
    margin: auto
    transition: all .3s ease-in-out

.preview-mobile
  .setup-previewer
    width: 35%
    height: 40vw

.preview-tablet
  .setup-previewer
    width: 50%
    height: 40vw

.preview-desktop
  .setup-previewer
    width: 100%
    height: 40vw
</style>
